import { gql } from '@apollo/client';

export const CANCEL_CAMPAIGN_MESSAGE = gql`
  mutation CancelCampaignMessage($id: ID!) {
    cancelCampaignMessage(input: { id: $id }) {
      campaignMessage {
        id
        status
        scheduledFor
      }
      errors
    }
  }
`; 